import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Cookie, X } from 'lucide-react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Show banner after a short delay
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    localStorage.setItem('cookie_consent_date', new Date().toISOString());
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookie_consent', 'declined');
    localStorage.setItem('cookie_consent_date', new Date().toISOString());
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 bg-slate-900/95 backdrop-blur-sm border-t border-slate-700 shadow-2xl animate-in slide-in-from-bottom duration-300">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex items-start gap-3 flex-1">
          <div className="w-10 h-10 bg-amber-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
            <Cookie className="w-5 h-5 text-amber-400" />
          </div>
          <div>
            <h3 className="font-semibold text-white mb-1">We use cookies</h3>
            <p className="text-slate-300 text-sm">
              We use essential cookies to make our site work. With your consent, we may also use non-essential cookies to improve your experience. 
              Read our{' '}
              <Link to="/cookies" className="text-amber-400 hover:underline">Cookie Policy</Link>
              {' '}and{' '}
              <Link to="/privacy" className="text-amber-400 hover:underline">Privacy Policy</Link>.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3 w-full md:w-auto">
          <Button
            onClick={declineCookies}
            variant="outline"
            className="flex-1 md:flex-none border-slate-600 text-slate-300 hover:bg-slate-800 hover:text-white"
          >
            Decline
          </Button>
          <Button
            onClick={acceptCookies}
            className="flex-1 md:flex-none bg-amber-500 hover:bg-amber-600 text-white font-semibold"
          >
            Accept All
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
